jQuery(document).ready(function($){
   $(".fancybox").fancybox({
        openEffect: "elastic",
        closeEffect: "elastic",
		helpers : {
			media : {}
		}
    });
  
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)){
    $('.is-mega').bind('mouseenter',function() {
      $(this).addClass('hover');
    });
    $('.is-mega iframe').bind('hover',function() {
      $(this).parents(".is-mega").addClass('hover');
    });
    $(".is-mega").bind('mouseleave',function() {
      $(this).removeClass('hover');
    });
  }

  /// Crop and scale images to a ratio
  $(window).on('load', function(){
    //$('#col-main .product-image .main-image').cropImageToRatio({ ratio: 10/13 });
  });
  
  $(window).scroll(function(){
    if ($(this).scrollTop() > 2500) {
        $('#buy-now-scroll').fadeIn('slow',function(){$(this).css({'width':'auto', 'height':'auto', 'position': 'fixed', 'top': 'auto', 'bottom':'10px', 'right':'20px'});});
    } else {
        $('#buy-now-scroll').fadeOut('slow');
    }
});
  
  jQuery(document).on('click', '.zmdi-close', function() {
  // target iframes with src attribute containing 'youtube'
  // (within the facebox-generated .popup wrapper).
  var vid = jQuery('.responsive-video iframe[src*="youtube"]');
  // if such an element exists
  if ( vid.length > 0 ){
    // get iframe's src attribute and cache it to a variable
    var src = vid.attr('src');
    // empty the iframe's src attribute
    // (this will kill the video playing)
    vid.attr('src', '');
    // and restore the iframe src url, ready to be played
    // again when the lightbox is displayed
    vid.attr('src', src);
  }
});
  
    jQuery(document).on('click', 'body.ctl-active', function() {
  // target iframes with src attribute containing 'youtube'
  // (within the facebox-generated .popup wrapper).
  var vid = jQuery('.responsive-video iframe[src*="youtube"]');
  // if such an element exists
  if ( vid.length > 0 ){
    // get iframe's src attribute and cache it to a variable
    var src = vid.attr('src');
    // empty the iframe's src attribute
    // (this will kill the video playing)
    vid.attr('src', '');
    // and restore the iframe src url, ready to be played
    // again when the lightbox is displayed
    vid.attr('src', src);
  }
});
  
  $("#address_phone_new").on("change keyup paste", function () {
    var output;
    var input = $("#address_phone_new").val();
    input = input.replace(/[^0-9]/g, '');
    var area = input.substr(0, 3);
    var pre = input.substr(3, 3);
    var tel = input.substr(6, 4);
    if (area.length < 3) {
        output = "(" + area;
    } else if (area.length == 3 && pre.length < 3) {
        output = "(" + area + ")" + " " + pre;
    } else if (area.length == 3 && pre.length == 3) {
        output = "(" + area + ")" + " " + pre + "-" + tel;
    }
    $("#address_phone_new").val(output);
});
  
  
  var timer;

$(".nav-dropdown-parent").on("mouseover", function() {
  clearTimeout(timer);
  openSubmenu();
}).on("mouseleave", function() {
  timer = setTimeout(
    closeSubmenu
  , 2000);
});

function openSubmenu() {
  $(".nav-dropdown").addClass("open");
}
function closeSubmenu() {
  $(".nav-dropdown").removeClass("open");
}

  

  
  
});

$(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });



  $(window).load(function() {
    $('.flexslider').flexslider({
      animation: "slide",
      randomize: true,
      controlNav: false,
      prevText: "",
      nextText: ""
    });
  });

/* Add to Cart Product page SV 20.Sep.19 */
(function($) {
  $(function() {
    $('.product-form button.add-to-cart').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var $form = $(e.currentTarget).closest('form.product-form');
      $form.submit();
    });
  });
})(jQuery)